module.exports = __webpack_public_path__ + "6b997ff3044ae3bb9e90e731ca59801d.svg";